export function scrollHorizontal(element, globalBounds) {
    const scrollWidth = element.scrollWidth;
    if (scrollWidth <= element.offsetWidth) {
        return;
    }
    const bounds = element.getBoundingClientRect();
    const relativeLeft = globalBounds.left - bounds.left;
    const relativeRight = globalBounds.right - bounds.right;
    const padding = Math.max(0, Math.min(bounds.width / 4, bounds.width - globalBounds.width));
    //TODO: animate?
    if (relativeLeft < 0) {
        element.scrollLeft = element.scrollLeft + relativeLeft - padding;
    }
    else if (relativeRight > 0) {
        element.scrollLeft = element.scrollLeft + relativeRight + padding;
    }
}
export function scrollVertical(element, globalBounds) {
    const scrollHeight = element.scrollHeight;
    if (scrollHeight <= element.offsetHeight) {
        return;
    }
    const bounds = element.getBoundingClientRect();
    const relativeTop = globalBounds.top - bounds.top;
    const relativeBottom = globalBounds.bottom - bounds.bottom;
    const padding = Math.max(0, Math.min(bounds.height / 4, bounds.height - globalBounds.height));
    if (relativeTop < 0) {
        element.scrollTop = element.scrollTop + relativeTop - padding;
    }
    else if (relativeBottom > 0) {
        element.scrollTop = element.scrollTop + relativeBottom + padding;
    }
}
